import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import type { UpdateCreditCalculationDto } from '../../../../backend/src/organisation/dto/update-credit-calculation.dto';
import { APIBaseChronos } from '../hosts';
import { QueryEntity } from '../types';
import useGetFetchConfig, { FetchMethod } from '../useGetFetchConfig';

export const useUpdateCreditCalculation = (orgId: string) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: UpdateCreditCalculationDto) => {
      const response = await fetch(
        `${APIBaseChronos}/api/org/${orgId}/credit-calculation`,
        getFetchConfig({ method: FetchMethod.PATCH, data }),
      );
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.message || 'Failed to update credit calculation');
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries([QueryEntity.OrganisationById, { orgId }]);
      queryClient.invalidateQueries([QueryEntity.OrganisationBillingPlanHistory, { orgId }]);
      toast.success('Credit calculation updated');
    },
    onError: (error: Error) => {
      toast.error(error.message);
    },
  });
};
